import React, { useEffect, useState } from "react";
import { getProductAverages } from "../services/api";
import ProductAveragesGraph from "../components/ProductAveragesGraph";
import HeaderCTA from "../components/HeaderCTA";
import DailyTicker from "../components/DailyTicker";
import FredDataGraph from "../components/FredDataGraph";
import Button from "../components/Button";
import CTA from "../components/CTA";
import TopStories from "../components/TopStories";
import SingleStateData from "../components/SingleStateGraph";
import Subscribe from "../components/Subscribe";
import RisingPricesSection from "../components/RisingPricesSection";
import StaticCopy from "../components/StaticCopy";
import SnowCanvas from "../components/SnowCanvas";

function Home() {
  const [prices, setPrices] = useState({
    TX: null,
    CA: null,
    VA: null,
  });

  useEffect(() => {
    const fetchStatePrices = async () => {
      try {
        const data = await getProductAverages();
        // console.log("Fetched Product Data:", data);

        // ✅ Helper function to get latest price for a state
        const getLatestPrice = (stateCode) => {
          const filteredPrices = data
            .filter(
              (item) =>
                item.state === stateCode && item.product_category === "Egg 12ct"
            )
            .sort((a, b) => new Date(b.record_day) - new Date(a.record_day));

          return filteredPrices.length > 0
            ? parseFloat(filteredPrices[0].average_price).toFixed(2)
            : null;
        };

        setPrices({
          TX: getLatestPrice("TX"),
          CA: getLatestPrice("CA"),
          VA: getLatestPrice("VA"),
        });
      } catch (error) {
        console.error("Failed to fetch egg prices:", error);
      }
    };

    fetchStatePrices();
  }, []);

  return (
    <div>
      {/* ✅ Dropdown for selecting a state */}
      <div className="flex justify-center mb-4"></div>

      {/* ✅ Pass selected state to HeaderCTA */}
      <HeaderCTA />

      <DailyTicker
        texasPrice={prices.TX}
        californiaPrice={prices.CA}
        virginiaPrice={prices.VA}
      />
      {/* Comment out seasonal bubble */}
      {/* <div className="holiday-snow-wrapper relative w-full rounded-[38px] overflow-hidden">
        <SnowCanvas />

        <section className="relative flex flex-col items-center space-y-4 pt-8 max-w-6xl justify-center mx-2 sm:mx-auto">

          <div
            className="relative z-10 flex flex-col items-start justify-center w-full rounded-[38px] shadow-lg p-12 space-y-4
                bg-gradient-to-br from-[#1F3D2B] to-[#3E6B4F]

                 border border-[#E6C7C2] text-[#2B2B2B] mx-auto mb-8"
          >
            <p className="mb-4 pb-4 font-normal text-white text-[32px] leading-tight font-barlow">
              This holiday season, shoppers are seeing prices go up.
            </p>

            <Button
              href={"#nationalGroceryTracker"}
              text={"See National Trends on Pork, Corn, Steak & More"}
              color={"#8B1E1E"}
              textColor="white"
              bgColor={"#8B1E1E"}
            />
          </div>
        </section>
      </div> */}
      <section className="flex flex-col items-center space-y-4 pt-4 max-w-6xl justify-center mx-2 sm:mx-auto">
        <FredDataGraph />
      </section>

      <section className="flex flex-col items-center space-y-4 pt-8 max-w-6xl justify-center mx-2 sm:mx-auto">
        <div
          className="flex flex-col items-start justify-center rounded-[38px] w-full bg-[#f6f8ff] rounded-xl shadow-lg p-12 space-y-3 min-h-fit rounded-3xl text-white mx-auto max-h-xl min-h-xl leading-tight mb-8"
          style={{ backgroundColor: "#E8EA58" }}
        >
          <p className="text-md font-bold uppercase tracking-wider mb-4 text-[#231F21] max-w-[70%]">
            Rising prices, shrinking wallets
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[5rem] font-bold mb-6 leading-tight text-[#231F21]">
            The cost of living for hardworking Americans continues to climb.
          </h2>
          <p className="mb-4 font-normal text-lg tracking-[0] pb-4 text-[#231F21] max-w-[70%]">
            Some of the most essential products in your grocery cart have seen
            dramatic price increases. While families are struggling to make ends
            meet, corporations are reaping rewards. This page breaks down how
            these prices have changed under the Trump administration and
            Republican control of Congress and what federal policies contribute
            to rising costs.
          </p>

          <a
            href={"/search-by-state-fred"}
            className="inline-block w-full md:w-1/2 text-center leading-[40px] uppercase transition-transform duration-200 hover:scale-105 font-bold"
            style={{
              backgroundColor: "black",
              color: "white",
              border: `3px solid black`,
              boxShadow: `-4px 4px 0 0 black`,
            }}
          >
            See State-level grocery prices
          </a>
        </div>
      </section>

      <section className="flex flex-col items-center space-y-4 pt-8 max-w-6xl justify-center mx-2 sm:mx-auto">
        <div
          className="flex flex-col items-start justify-center rounded-[38px] w-full bg-[black] rounded-xl shadow-lg p-12 space-y-3 min-h-fit rounded-3xl text-white mx-auto max-h-xl min-h-xl leading-tight mb-8"
          style={{ backgroundColor: "black" }}
        >
          <h2 className="font-bold uppercase tracking-wider ">Daily Tracker</h2>
          <p className="mb-4 pb-4 font-normal text-[32px] leading-tight font-barlow">
            How the prices of eggs, milk, meat, bread, and coffee have soared
            under his watch.
          </p>

          <Button
            href={"/search-by-state-fred"}
            text={"See State-level grocery prices"}
            color={"#E8EA58"}
            textColor="black"
            bgColor={"#E8EA58"}
          />
        </div>
      </section>

      {/* <section className="flex flex-col sm:flex-row sm:items-stretch sm:space-x-4 space-y-4 sm:space-y-0 pt-2 pb-8 mx-2 sm:mx-auto max-w-6xl">
        <div className="w-full sm:w-1/2">
          <SingleStateData state="CA" />
        </div>

        <div
          className="w-full sm:w-1/2 flex flex-col items-start justify-center rounded-[38px] bg-[#f6f8ff] shadow-lg p-12 space-y-3 text-white mx-auto"
          style={{ backgroundColor: "black" }}
        >
          <h2 className="font-bold uppercase tracking-wider ">Daily Tracker</h2>
          <p className="mb-4 pb-4 font-normal text-[32px] leading-tight font-barlow">
            How the prices of eggs, milk, meat, bread, and coffee have soared
            under his watch.
          </p>

          <Button
            href={"/search-by-state-fred"}
            text={"See State-level grocery prices"}
            color={"#E8EA58"}
            textColor="black"
            bgColor={"#E8EA58"}
          />
        </div>
      </section> */}

      <div className="pt-8">
        <StaticCopy
          bg="#E8EA58"
          eyebrow="IT’S A FACT!"
          header={
            <>
              About 6 in 10 Americans are “extremely” or “very” concerned about
              the cost of groceries.
            </>
          }
          subtext={
            <>
              <a
                href="https://apnews.com/article/trump-economy-poll-tariffs-inflation-prices-recession-1d320115e8801e4970bd5cccf2742fc4"
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
              >
                Most Americans
              </a>{" "}
              are concerned about rising costs and their ability to support
              their families.
            </>
          }
        />
      </div>

      <div className="">
        <CTA />
        <RisingPricesSection />
        <TopStories />
      </div>
      <div className="pb-8">
        <StaticCopy
          bg="#E8EA58"
          eyebrow="IT’s A FACT!"
          header={
            <>
              Nearly two-thirds of Americans disapprove of Trump and
              Republicans’ tariffs
            </>
          }
          subtext={
            <>
              <a
                href="https://abcnews.go.com/Politics/thirds-americans-disapprove-trump-tariffs-inflation-broad-concern/story?id=121123815"
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
              >
                47% of Republicans and 75% of Independents
              </a>{" "}
              said they think tariffs will negatively impact inflation.
            </>
          }
        />
      </div>

      <Subscribe />
    </div>
  );
}

export default Home;
